import React, { useEffect, useState } from 'react';
import HeaderComponent from '../../component/base/header-component/HeaderComponent';
import FooterComponent from '../../component/base/footer-component/FooterComponent';
import '../../assets/scss/page/feedback-page-style.scss';
import QuestionStarComponent from '../../component/base/onboard-question-component/QuestionStarComponent';
import QuestionSelectComponent from '../../component/base/onboard-question-component/QuestionSelectComponent';
import QuestionTextComponent from '../../component/base/onboard-question-component/QuestionTextComponent';
import OnboardButton from '../../component/base/onboard-button-component/OnboardButton';
import { firstCharacterUpper } from '../../util/CharacterUtil';
import CompletedComponent from '../../component/base/completed-component/CompletedComponent';
import { data } from '../../example/getFilteredSurveyQuestion';
import OnboardDialog from '../../component/base/onboard-dialog-component/OnboardDialog';
import { setSimulationNumber } from '../../util/SimulationManager';

const FeedbackPage = (props) => {
    const { t, i18n, navigate, location, user, setLoading, handleInformation } = props.props;
    const simulationNumber = setSimulationNumber();
    const [questions, setQuestions] = useState([]);
    const [answers, setAnswers] = useState([]);
    const [errorDialog, setErrorDialog] = useState({ visible: false });

    useEffect(() => {
        handleInformation('feedback');
        simulationNumber(8, 1);
    }, []);

    useEffect(() => {
        getQuestions();
        setupCompleted();
    }, [i18n.language]);

    const getQuestions = () => {
        setLoading(true);
        let questions;
        let res = data;
        if (res !== null && res.data !== null) {
            questions = res.data;
            questions = getAnswer(questions);
        }
        console.log(questions);
        setQuestions(questions);
    };

    const getAnswer = (questions) => {
        setLoading(true);
        questionToAnswer(questions);
        setLoading(false);
        return questions;
    };

    const questionToAnswer = (questions) => {
        if (questions != null)
            questions.forEach(question => {
                if (question.questionType === 'SELECT' || question.questionType === 'STAR') {
                    let result = false;
                    answers.forEach(value => {
                        if (value.id === parseInt(question.id)) result = true;
                    });
                    if (!result)
                        answers.push({ id: parseInt(question.id), value: null });
                }
            });
    };

    const renderQuestions = () => {
        if (questions == null) return <p className="m-b-34">{t('system_status.service_unavailable')}</p>;
        return questions?.map((question, index) => {
            if (question.questionType === 'STAR') return renderQuestionStar(index + 1, question);
            else if (question.questionType === 'SELECT') return renderQuestionSelect(index + 1, question);
            else if (question.questionType === 'TEXT') return renderQuestionText(index + 1, question);
        });
    };

    const renderQuestionStar = (index, question) => {
        return (<div key={'star_' + index} className="feedback-page-question-root">
            <p className="feedback-page-question-text">{index + '- ' + question.text}</p>
            <QuestionStarComponent value={question.value} error={question.error}
                                   select={(val) => setupAnswer(question.id, val)} />
        </div>);
    };

    const renderQuestionSelect = (index, question) => {
        return (<div key={'select_' + index} className="feedback-page-question-root">
            <p className="feedback-page-question-text">{index + '- ' + question.text}</p>
            <QuestionSelectComponent value={question.value} error={question.error} options={question.options}
                                     select={(val) => setupAnswer(question.id, val.id)} />
        </div>);
    };

    const renderQuestionText = (index, question) => {
        return (<div key={'text_' + index} className="feedback-page-question-root">
            <p className="feedback-page-question-text">{index + '- ' + question.text}</p>
            <QuestionTextComponent value={question.value} label={question.label}
                                   select={(val) => setupAnswer(question.id, val)} />
        </div>);
    };

    const confirm = () => {
        if (!valid()) {
            setCompleted({ ...completed, visible: true, error: false });
            //setErrorDialog({...errorDialog, visible: true})
        }
    };

    const valid = () => {
        let error = false;
        answers.forEach(answer => {
            let qList = [];
            questions.forEach(question => {
                if (question.id === answer.id) {
                    if (answer.value === null || answer.value === 'undefined') {
                        question.error = true;
                        error = true;
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                    }
                }
                qList.push(question);
            });
            setQuestions(qList);
        });
        return error;
    };

    const setupAnswer = (id, val) => {
        let isText = true;
        let recordAnswer = answers;
        recordAnswer.forEach(record => {
            if (record.id === id) {
                if (val === null) record.value = val;
                else record.value = val + '';
                isText = false;
            }
        });
        if (isText) recordAnswer.push({ id: parseInt(id), value: val + '' });
        setAnswers(recordAnswer);
    };

    const setupCompleted = () => {
        setCompleted({
            visible: false,
            error: false,
            title: t('feedback.confirm_success'),
            titleError: t('error.an_unknown_error'),
            confirmText: (location.state === 'login' ? t('login.login_btn') : t('payment.success.confirm'))
        });
    };

    const [completed, setCompleted] = useState({
        visible: false,
        error: false,
        title: t('feedback.confirm_success'),
        titleError: t('error.an_unknown_error'),
        confirmText: (location.state === 'login' ? t('login.login_btn') : t('payment.success.confirm'))
    });

    const getContactUs = () => {
        let link = 'https://www.turkishairlines.com/en-int/any-questions/customer-relations/feedback/';
        window.open(link, '_blank', 'noopener, noreferrer');
    };

    return (
        <div>
            <HeaderComponent
                title={t('home.title') + ' ' + firstCharacterUpper(user?.name) + (user?.name ? ',' : '')}
                content={t('feedback.title')} />

            <div className="content-root">

                {renderQuestions()}

                {questions && (
                    <OnboardButton label={t('feedback.evaluate')} onClick={() => confirm()} />
                )}

                <p onClick={() => {
                    simulationNumber(9, 1);
                    (location.state !== 'login' ? navigate('/login') : navigate(-1));
                }}
                   className="cancel">{t('back')}</p>

            </div>

            <FooterComponent />

            <CompletedComponent
                visible={completed.visible}
                error={completed.error}
                title={completed.error ? completed.titleError : completed.title}
                confirmText={completed.confirmText} hiddenCopy
                confirm={() => {
                    if (completed.error) setCompleted({ ...completed, visible: false });
                    else {
                        if (location.state === null) navigate('/login');
                        else navigate(-1);
                    }
                }} />

            <OnboardDialog error
                           visible={errorDialog.visible}
                           title={''}
                           content={t('system_status.service_unavailable').toString()
                               .replace('{link}',
                                   /tr/.test(i18n.language.toLowerCase()) ?
                                       `<a href="https://www.turkishairlines.com/tr-int/bilgi-edin/musteri-iliskileri/geribildirim/index.html" target="_blank">${t('feedback.error_max_send_link')}</a>` :
                                       `<a href="https://www.turkishairlines.com/en-int/any-questions/customer-relations/feedback/" target="_blank">${t('feedback.error_max_send_link')}</a>`)}
                           cancelShow cancelText={t('home.close')}
                           onClickCancel={() => setErrorDialog({ ...errorDialog, visible: false })}
            />

        </div>
    );
};

export default FeedbackPage;

